<script lang="ts">
    // Une "section" generique, avant que le autour de la section en soi.
    // "Affiche titre avec type, undo, etc.."
    //
    import { onDestroy } from 'svelte'
    import { slide } from 'svelte/transition'

    import Icon from '@iconify/svelte'
    import { cloneDeep, isEqual } from 'lodash-es'

    import { gettext as _, resolve } from 'hydria/services/gettext'

    import type { ISectionTypes, ISimpleHtmlSection } from '../models'
    import { SECTION_TYPES } from '../sections'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    interface Props {
        sectionEdit: ISectionTypes
        sectionSaved: ISectionTypes
        isFirst: boolean
        isLast: boolean
        disabled: boolean

        remove: () => void
        moveUp: () => void
        moveDown: () => void
    }

    let { sectionEdit = $bindable(), sectionSaved, isFirst, isLast, disabled, remove, moveUp, moveDown }: Props = $props()

    let isPristine = $derived(isEqual(sectionSaved, sectionEdit))
    let isNew = $derived(sectionSaved == null)

    function removeSection() {
        remove()
    }
    function updateSection(data: ISimpleHtmlSection) {
        // sectionEdit = Object.assign($state.snapshot(sectionEdit), data)
        console.log('in updateSection')
        sectionEdit = Object.assign(sectionEdit, data)
        console.log('in updateSection - set done')
    }
    function undoSection() {
        sectionEdit = cloneDeep($state.snapshot(sectionSaved))
    }

    // Simple fermer/ouvrir pour la section, pour espace visuel
    let visibility: boolean = $state(true)
</script>

<div class="card">
    <div class="card-header text-bg-primary d-flex align-items-center gap-3">
        <div class="ordering">
            <div class="btn-group btn-group-sm">
                <button
                    type="button"
                    class="btn btn-sm btn-outline-light"
                    disabled={disabled || isFirst}
                    onclick={() => {
                        moveUp()
                    }}><Icon inline icon="mdi:chevron-up" /></button
                >
                <button
                    type="button"
                    class="btn btn-sm btn-outline-light"
                    disabled={disabled || isLast}
                    onclick={() => {
                        moveDown()
                    }}><Icon inline icon="mdi:chevron-down" /></button
                >
            </div>
        </div>
        <div class="card-visibility">
            <button type="button" class="btn btn-sm btn-light tt-right" onclick={() => (visibility = !visibility)} data-tooltip={$_('Cacher le contenu')}>
                <Icon inline icon={visibility ? 'mdi:eye-outline' : 'mdi:eye-off-outline'} />
            </button>
        </div>
        <div class="title col">{SECTION_TYPES[sectionEdit.section_type] ? $resolve(SECTION_TYPES[sectionEdit.section_type].title) : ''}</div>
        <div class="actions">
            {#if isNew}
                <button type="button" class="btn btn-sm btn-warning" disabled data-tooltip={$_('Nouvelle section')}><Icon inline icon="mdi:liquid-spot" /></button>
            {:else if isPristine}
                <button type="button" class="btn btn-sm btn-success tt-left" disabled data-tooltip={$_('Section non-modifiée')}><Icon inline icon="mdi:check-circle" /></button>
            {:else}
                <button type="button" class="btn btn-sm tt-left" class:btn-outline-secondary={isNew || isPristine} class:btn-warning={!isNew && !isPristine} disabled={disabled || isNew || isPristine} data-tooltip={$_('Revenir à la version sauvegardée')} onclick={() => undoSection()}><Icon inline icon="mdi:undo" /></button>
            {/if}
            <button type="button" class="btn btn-sm btn-danger tt-left" {disabled} onclick={() => removeSection()} data-tooltip={$_('Enlever cette section')}><Icon inline icon="mdi:trash" /></button>
        </div>
    </div>
    {#if visibility && SECTION_TYPES[sectionEdit.section_type]}
        {@const SvelteComponent = SECTION_TYPES[sectionEdit.section_type].component}
        <div class="card-body" transition:slide|local={{ duration: 250 }}>
            <SvelteComponent {sectionEdit} {sectionSaved} {disabled} set={(e) => updateSection(e)} />
        </div>
    {/if}
</div>
